import { useFeatureFlags } from "@/hooks/useFeatureFlags";
import { cn } from "@/lib/utils";
import Image from "next/image";

import { Text } from "./Text";
import { Footer } from "./templates/Footer";

export const Empty = ({
    imgurl,
    mainText,
    subText,
    className,
    ...props
}: {
    className?: string;
    imgurl: string;
    mainText: string | React.ReactNode;
    subText?: string | React.ReactNode;
}) => {
    const { isFeatureEnabled } = useFeatureFlags();
    return (
        <div className={cn("flex h-[60vh] flex-col", className)} {...props}>
            {/* Content area that grows to fill available space */}
            <div className="flex flex-1 flex-col items-center justify-center">
                <div className="relative mb-9 h-[140px] w-[140px]">
                    <Image alt="empty" src={imgurl} fill />
                </div>
                {typeof mainText === "string" ? (
                    <Text
                        className="!important md:text-h4 mb-3 break-keep
                            text-center font-medium md:mb-2"
                        variant="h3"
                    >
                        {mainText}
                    </Text>
                ) : (
                    mainText
                )}
                {subText &&
                    (typeof subText === "string" ? (
                        <Text
                            className="md:text-body3 whitespace-pre-wrap
                                text-center"
                            variant="body1"
                            color="text.disabled"
                        >
                            {subText}
                        </Text>
                    ) : (
                        subText
                    ))}
            </div>
        </div>
    );
};
